import React from 'react';
import { Layout, Menu } from 'antd';
import { NavLink } from 'react-router-dom';

import { useIsLOCadmin } from '@hooks';

import { setLinkColorVars } from './utils';
import {
  DASHBOARD_ITEMS,
  CONTENT_SUPER_ADMIN_ITEMS,
  CONTENT_LOC_ADMIN_ITEMS,
  SETUP_SUPER_ADMIN_ITEMS,
  SETUP_LOC_ADMIN_ITEMS,
  BOOK_OF_RULES_ITEMS,
} from './constants';
import s from './styles.module.less';

const Sider = () => {
  const isLOCAdmin = useIsLOCadmin();

  const contentItems = isLOCAdmin ? CONTENT_LOC_ADMIN_ITEMS : CONTENT_SUPER_ADMIN_ITEMS;
  const setupItems = isLOCAdmin ? SETUP_LOC_ADMIN_ITEMS : SETUP_SUPER_ADMIN_ITEMS;

  return (
    <Layout.Sider className={s.sider}>
      <Menu>
        {DASHBOARD_ITEMS.map(renderMenuItem)}
        <Menu.ItemGroup title="CONTENT">{contentItems.map(renderMenuItem)}</Menu.ItemGroup>
        <Menu.ItemGroup title="SETUP">{setupItems.map(renderMenuItem)}</Menu.ItemGroup>
        {!isLOCAdmin && (
          <Menu.ItemGroup title="BOOK OF RULES">{BOOK_OF_RULES_ITEMS.map(renderMenuItem)}</Menu.ItemGroup>
        )}
      </Menu>
    </Layout.Sider>
  );
};

const renderMenuItem = (item) => (
  <Menu.Item key={item.key}>
    <NavLink
      title={item.tooltip}
      activeClassName="selected"
      style={setLinkColorVars(item)}
      to={item.href}
      end={item.end}
    >
      {item.title}
    </NavLink>
  </Menu.Item>
);

export default Sider;
